<template>
    <overlay-pop ref="pop"
                 btn-variant="light"
                 btn-icon="fa-solid fa-caret-down"
                 btn-class="position-relative"
                 class="filter-btn"
                 trigger="focus"
                 popup-placement="bottomright"
                 @hide="aboutToHide">
        <div class="d-flex flex-column">
            <div class="w-100 text-center label-text">{{ label }}</div>
            <template id="sort" v-if="!disableSort">
                <div class="category-text">Sort</div>
                <sort-switch :sorting-by="sortBy" :current-key="fieldKey" :desc="sortDesc"
                             @change="changeSort"></sort-switch>
            </template>
            <template id="filter" v-if="filterActivate">
                <div class="category-text">Filter</div>
                <b-form-input size="sm" class="search-input" debounce="300" trim
                              v-model="filterSearch" placeholder="Search"></b-form-input>
                <div v-if="searchResultEmpty" class="font-weight-bold text-center w-100">No items match</div>
                <div v-else class="d-flex flex-column overflow-auto" style="max-height: 200px;" id="container">
                    <div class="d-flex flex-row mr-3">
                        <b-form-checkbox v-if="checkForceLoad"
                                         :checked="!isSelectNone()"
                                         :indeterminate="isSelectPart()"
                                         @change="triggerSelectAll"/>
                        (Select All)
                    </div>
                    <template v-for="item of viewSet">
                        <div class="d-flex flex-row mr-3" :key="item">
                            <b-form-checkbox :checked="!disableSet.has(item)"
                                             @change="whenCheckChange($event, item);">
                            </b-form-checkbox>
                            {{ item }}
                        </div>
                    </template>
                </div>
            </template>
            <template id="group" v-if="groupActivate">
                <div class="category-text">Group</div>
                <div class="d-flex flex-row">
                    <b-form-select class="w-100" :options="dateSplitUnits"
                                   v-model="dateSplitUnit"></b-form-select>
                    <b-button v-if="dateSplitUnit>=0" pill class="ml-1" variant="light"
                              @click="clearGroup">
                        <i class="fa-solid fa-xmark"></i>
                    </b-button>
                </div>
            </template>
        </div>
        <template #button>
            <div class="dot" :style="dotColor" v-if="dotColor"></div>
        </template>
    </overlay-pop>
</template>

<script>
import OverlayPop from "@/components/workflow/stuffs/OverlayPop.vue";
import emCommonUtilMixin from "@/mixin/em/common/stuffs/utils/emCommonUtilMixin";
import dateUtilMixins from "@/components/echarts-part/TableChart/mixins/date-util-mixins";
import _ from 'lodash'
import SortSwitch from "@/components/common/buttons/SortSwitch.vue";

const DOT_COLOR = {
    3: '#3d70b0',
    5: '#fab833',
    7: '#319c45',
    15: '#d168cc',
    21: '#d168cc',
    35: '#d168cc',
}

export default {
    name: "SortFilterDropdown",
    mixins: [emCommonUtilMixin, dateUtilMixins],
    components: {SortSwitch, OverlayPop},
    props: {
        label: String,
        rows: Array,
        fieldKey: String,
        keepCatch: {
            type: Boolean,
            default: false
        },
        disableSort: {
            type: Boolean,
            default: false
        },
        sortBy: String,
        sortDesc: Boolean,

        groupingBy: String,
    },
    data() {
        return {
            distinctSet: new Set(),
            disableSet: new Set(),

            filterSearch: null,
            filteredSet: null,
            searchResultEmpty: false,
            hiding: false,

            changeFlag: 0,
            checkForceLoad: true,

            filterActivate: true,
            //---group---
            groupActivate: false,
            dateSplitUnit: -1,
        }
    },
    computed: {
        selectAllStatus() {
            if (this.changeFlag) {
                //refresh
            }
            let disableSize = this.disableSet.size;
            if (disableSize === 0) {
                return 1;//全选
            } else if (disableSize === this.distinctSet.size) {
                return 0;//空
            } else {
                return 2;//部分选择
            }
        },
        dotColor() {
            let tag = 1;
            if (!this.disableSort && this.sortBy === this.fieldKey) {
                tag *= 3;
            }
            if (!this.isSelectAll()) {
                tag *= 5;
            }
            if (this.grouping) {
                tag *= 7;
            }
            return tag > 1 ? `background-color: ${DOT_COLOR[tag]};` : null;
        },
        viewSet() {
            return this.hasCode(this.filterSearch) ? this.filteredSet : this.distinctSet
        },
        grouping() {
            return this.groupingBy === this.fieldKey;
        },
    },
    watch: {
        rows: {
            handler() {
                this.distinctCells();
                this.$forceUpdate();
            },
            deep: true,
            immediate: true,
        },
        filterSearch(val) {
            if (!this.hiding) {
                this.doSearch(val);
            }
        },
        dateSplitUnit() {
            this.handleSplitUnitChange();
        },
        groupingBy() {
            if (!this.grouping) {
                this.dateSplitUnit = -1;
            }
        },
    },
    beforeDestroy() {
        this.$emit("clear");
    },
    methods: {
        distinctCells() {
            let hasBlank = false;
            let tempSet = this.keepCatch ? this.distinctSet : new Set();
            for (let row of this.rows) {
                let item = row[this.fieldKey];
                if (!this.hasCode(item)) {
                    hasBlank = true;
                } else if (!tempSet.has(item)) {
                    if (this.isDate(item)) {
                        //日期处理
                        this.handleDateField();
                        return;
                    }
                    tempSet.add(item);
                }
            }
            this.distinctSet = tempSet;
            this.sortDistinctSet();
            if (hasBlank) {
                this.distinctSet.add('(blanks)');
            }
        },
        recoverDistinctCells() {
            if (this.disableSet.size > 0) {
                for (let item of this.disableSet) {
                    this.distinctSet.add(item);
                }
                this.sortDistinctSet();
            }
        },
        sortDistinctSet() {
            let sortedArray = Array.from(this.distinctSet).sort();
            this.distinctSet = new Set(sortedArray);
        },
        //----handle user's operation----
        whenCheckChange(event, item) {
            if (event) {
                this.disableSet.delete(item);
            } else {
                this.disableSet.add(item);
            }
            this.changed();
        },
        triggerSelectAll() {
            if (!this.isSelectAll()) {
                if (this.isSelectPart()) {
                    this.forceRefreshCheckView();
                }
                this.selectAll();
            } else {
                this.clear();
            }
            this.changed();
        },
        selectAll() {
            this.disableSet.clear();
        },
        clear() {
            for (let item of this.distinctSet) {
                this.disableSet.add(item);
            }
        },
        changed() {
            this.changeFlag = new Date().getTime();
            this.changeFilter();
            this.$forceUpdate();
        },
        //----select judge----
        isSelectPart() {
            return this.selectAllStatus === 2;
        },
        isSelectAll() {
            return this.selectAllStatus === 1;
        },
        isSelectNone() {
            return this.selectAllStatus === 0;
        },
        //----emit event----
        changeFilter() {
            if (this.isSelectPart()) {
                this.$emit('filterChange', this.disableSet);
                this.emitCheckedSet();
            } else if (this.isSelectAll()) {
                this.$emit('noFilter');
            }
        },
        emitCheckedSet() {
            let temp = new Set();
            for (let item of this.viewSet) {
                if (!this.disableSet.has(item)) {
                    temp.add(item);
                }
            }
            this.$emit("checkedChange", temp);
        },
        changeSort(desc) {
            this.$emit('sortChange', {
                key: this.fieldKey,
                desc: desc
            })
        },
        //----search----
        doSearch(val) {
            if (this.hasCode(val)) {
                let tempSet = new Set();
                let searchReg = this.getSearchReg(_.upperCase(val));
                for (let item of this.distinctSet) {
                    let s = _.upperCase(item);
                    if (searchReg.test(s)) {
                        tempSet.add(item);
                        this.disableSet.delete(item);
                    } else {
                        this.disableSet.add(item);
                    }
                }
                if (tempSet.size === 0) {
                    this.searchResultEmpty = true;
                } else {
                    this.searchResultEmpty = false;
                    this.filteredSet = tempSet;
                }
            } else {
                this.filteredSet = this.distinctSet;
                this.recoverDisables();
            }
            this.changed();
        },
        aboutToHide() {
            this.hiding = true;
            if (this.searchResultEmpty) {
                this.recoverDisables();
                this.searchResultEmpty = false;
            }
            if (this.hasCode(this.filterSearch)) {
                this.filterSearch = null;
                this.filteredSet = null;
                this.recoverDistinctCells();
                this.changeFlag = new Date().getTime();
            }
            this.$nextTick(() => this.hiding = false);
        },
        recoverDisables: function (set = this.distinctSet) {
            if (this.filteredSet && this.filteredSet.size > 0) {
                set = this.filteredSet;
            }
            for (let item of set) {
                this.disableSet.delete(item);
            }
        },
        //----others----
        forceRefreshCheckView: function () {
            this.checkForceLoad = false;
            this.$nextTick(() => {
                this.checkForceLoad = true;
                let uuid = this.$refs.pop.uuid;
                let el = document.getElementById(uuid);
                el && el.focus();
            });
        },
        //----date group----
        handleDateField() {
            this.groupActivate = true;
            this.filterActivate = false;
        },
        handleSplitUnitChange() {
            if (this.dateSplitUnit >= 0) {
                let temp = _.filter(this.rows, row => row._isGroupTag !== true);
                let groupRowByDate = this.groupRowByDate(temp, row => row[this.fieldKey], this.dateSplitUnit);
                let tempMap = {};
                for (let str of Object.keys(groupRowByDate)) {
                    let tempSet = new Set();
                    let rows = groupRowByDate[str];
                    for (let row of rows) {
                        let item = row[this.fieldKey];
                        tempSet.add(item);
                    }
                    tempMap[str] = tempSet;
                }
                this.$emit('dateGroup', {groupMap: tempMap, groupWay: this.dateSplitUnit});
            } else {
                this.$emit('dateGroup', null);
            }
        },
        clearGroup() {
            this.dateSplitUnit = -1;
        },
        recoverFilterByChecked(set) {
            this.distinctCells();
            let temp = new Set();
            if (set != null && set.size > 0) {
                for (let item of this.viewSet) {
                    if (!set.has(item)) {
                        temp.add(item);
                    }
                }
            }
            this.disableSet = temp;
            this.changed();
        },
    }
}
</script>

<style scoped>
.filter-btn >>> .btn {
    padding: 0 0.25rem !important;
}

#container::-webkit-scrollbar {
    width: 1px;
    background-color: transparent;
}

#container::-webkit-scrollbar-thumb {
    border-radius: 1px;
    background-color: rgb(128, 128, 128);
}

.dot {
    width: 7px;
    height: 7px;
    border-radius: 50%;
    position: absolute;
    top: -3px;
    right: -3px;
}

.label-text {
    font-size: .75rem;
    font-weight: bold;
    margin-bottom: 0.25rem;
    border-bottom: #cccccc 1px solid;
}

.category-text {
    font-weight: bold;
}

.search-input {
    height: 23px !important;
    border-radius: 12px !important;
}
</style>
